var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DividedList',{attrs:{"items":_vm.items,"empty-message":_vm.$t('no_committees_existing'),"list-item":_vm.CommitteeListItem}})
}
var staticRenderFns = []

export { render, staticRenderFns }